<template>
  <!-- 顶部导航 -->
  <div>
    <!-- <div class="pc-nav-shadow">
    </div> -->
    <div
      class="pc-nav outer"
      :class="{
        whitebg: iswhitebg,
        white: iswhite
      }"
    >
      <div class="pc-nav-in inner flc">
        <div class="nav-img">
          <!-- <img class="logo" :src="!iswhite ? logobrand : logobrandw" /> -->
          <img class="logo-top" :src="!iswhite ? logobrand : logobrandw" />
        </div>
        <div class="nav-list flc">
          <!-- <div class="nav-link"
            @click="toIndex">
            首页
          </div> -->
          <div class="nav-link" @click="toRightSupervise">权力监督大数据</div>
          <div class="nav-link" @click="toPoliticEcology">政治生态监测大数据</div>
          <div class="nav-link" @click="toPoliticSupervise">政治监督大数据</div>
        </div>
        <!-- <div class="nav-append">
          <div class="color-btn flc" @click="toEcologyAssociation">生态联盟</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import logobrandw from '@/assets/logobrandw.png'
import logobrand from '@/assets/logobrand.png'

export default {
  name: 'pc-nav',
  props: {},
  data() {
    return {
      logobrand,
      logobrandw,
      iswhite: false,
      iswhitebg: true,
      mapbannercolor: {
        '/index': 'white',
        '/right-supervise': 'white',
        '/politic-ecology': 'black',
        '/politic-supervise': 'white',
        '/ecology-association': 'black'
      },
      mapbannerheight: {
        '/index': 1000,
        '/right-supervise': 580,
        '/politic-ecology': 580,
        '/politic-supervise': 580,
        '/ecology-association': 580
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onscroll)
    this.resetbasecolor(this.$route.fullPath)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onscroll)
  },
  watch: {
    '$route.fullPath'(newval) {
      this.resetbasecolor(newval)
    }
  },
  methods: {
    totop() {
      document.body.parentNode.scrollTo(0, 0)
    },
    toIndex() {
      if (this.$route.fullPath !== '/index') {
        this.$router.push({
          path: '/index'
        })
      } else {
        this.totop()
      }
    },
    toRightSupervise() {
      if (this.$route.fullPath !== '/right-supervise') {
        this.$router.push({
          path: '/right-supervise'
        })
      } else {
        this.totop()
      }
    },
    toPoliticEcology() {
      if (this.$route.fullPath !== '/politic-ecology') {
        this.$router.push({
          path: '/politic-ecology'
        })
      } else {
        this.totop()
      }
    },
    toPoliticSupervise() {
      if (this.$route.fullPath !== '/politic-supervise') {
        this.$router.push({
          path: '/politic-supervise'
        })
      } else {
        this.totop()
      }
    },
    toEcologyAssociation() {
      if (this.$route.fullPath !== '/ecology-association') {
        this.$router.push({
          path: '/ecology-association'
        })
      } else {
        this.totop()
      }
    },
    resetbasecolor(path) {
      const basecolor = this.mapbannercolor[path]
      this.iswhite = basecolor === 'white'
      this.iswhitebg = false
    },
    onscroll(e) {
      const htmlnode = document.body.parentNode
      const scrolltop = htmlnode.scrollTop
      const path = this.$route.fullPath
      const basecolor = this.mapbannercolor[path]
      // const bannerheight = this.mapbannerheight[path]
      if (scrolltop <= 10) {
        this.iswhite = basecolor === 'white'
        this.iswhitebg = false
      } else {
        this.iswhite = false
        this.iswhitebg = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pc-nav-shadow {
  height: 50px;
  width: 100%;
}
.pc-nav {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0.16) 100%);
  position: fixed;
  top: 0%;
  left: 0;
  z-index: 999;
  &.whitebg {
    background: white;
    box-shadow: 0px 0px 32px rgb(2, 80, 158, 0.14);
  }
  &.white {
    .pc-nav-in {
      height: 50px;
      .nav-img {
        > div {
          color: #fff;
        }
      }
      .nav-list {
        .nav-link {
          color: #fff;
        }
      }
    }
  }
  .pc-nav-in {
    height: 50px;
    width: 100%;
    // max-width: 1920px;
    min-width: 1460px;
    .nav-img {
      width: 214px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .logo {
        height: 33px;
        min-width: 113px;
        // margin-right: 8px;
      }
      .name {
        height: 24px;
        // margin-left: 10px;
      }
      // > img{
      //   width: 44px;
      //   height: 22px;
      //   margin-right: 8px;
      // }
      // > div {
      //   font-size: 22px;
      //   font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      //   font-weight: bold;
      //   color: #252525;
      //   line-height: 24px;
      //   transition: all .3s linear;
      // }
    }
    .nav-list {
      flex: 1;
      justify-content: flex-start;
      margin-left: 66px;
      .nav-link {
        font-size: 22px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #252525;
        line-height: 24px;
        cursor: pointer;
        padding: 0 36px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s linear;
      }
    }
    .nav-append {
      padding-right: 214px;
      .color-btn {
        width: 108px;
        height: 38px;
        background: linear-gradient(318deg, #6e3ef7 3%, #3e5feb 48%);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        font-size: 22px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 22px;
        cursor: pointer;
      }
    }
  }
}

.nav-img {
  display: flex;
  align-items: center;

  .logo-top {
    height: 30px;
  }

  .logo-text {
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
